const DEFAULT_CONFIG_FOR_CINEMAS_IN_THE_SAME_PAGE = {
  featureLeftLateralSpace: 16,
  marginBetweenCinemaTiles: 8,
  defaultNumberOfCinemaTiles: 5,
  clusters: [
    {
      belongs: (width) => width <= 497,
      tiles: 2
    },
    {
      belongs: (width) => 497 < width && width <= 636,
      tiles: 3
    },
    {
      belongs: (width) => 636 < width && width <= 767,
      tiles: 4
    }
  ]
};

export const calculateColumnWidthAlignedWithCinemas = (
  featureInjectionContainerWidth,
  {
    featureLeftLateralSpace,
    defaultNumberOfCinemaTiles,
    marginBetweenCinemaTiles,
    clusters
  } = DEFAULT_CONFIG_FOR_CINEMAS_IN_THE_SAME_PAGE
) => {
  const numberOfVisibleCinemaTiles = calculateNumberOfCinemaTiles(
    featureInjectionContainerWidth,
    defaultNumberOfCinemaTiles,
    clusters
  );
  const featureAvailableSpace = featureInjectionContainerWidth - featureLeftLateralSpace;
  const totalNumberOfVisibleCinemaTiles = numberOfVisibleCinemaTiles + 0.5;

  const totalMarginForVisibleCinemaTiles = numberOfVisibleCinemaTiles * marginBetweenCinemaTiles;

  const width =
    (featureAvailableSpace - totalMarginForVisibleCinemaTiles) / totalNumberOfVisibleCinemaTiles +
    8;

  return { width, numberOfVisibleCinemaTiles };
};

const calculateNumberOfCinemaTiles = (
  featureAvailableSpace,
  defaultNumberOfCinemaTiles,
  clusters
) => {
  const cluster = clusters.find(({ belongs }) => belongs(featureAvailableSpace));
  return cluster ? cluster.tiles : defaultNumberOfCinemaTiles;
};
